export function initBackToTop() {
	const btn = document.querySelector('.cs-back-to-top');
	if (!btn) return;

	const update = () => {
		btn.classList.toggle('is-visible', window.scrollY > 600);
	};

	window.addEventListener('scroll', update, { passive: true });
	btn.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});
	update();
}
